import { render, staticRenderFns } from "./urkunde_page_a3.vue?vue&type=template&id=c62d494a&scoped=true"
import script from "./urkunde_page_a3.vue?vue&type=script&lang=js"
export * from "./urkunde_page_a3.vue?vue&type=script&lang=js"
import style0 from "./urkunde_page_a3.vue?vue&type=style&index=0&id=c62d494a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62d494a",
  null
  
)

export default component.exports